import { FC } from 'react'
import { Row, Col, Content } from '@/client/components'
import * as S from './styles'
import { MoreInfosProps } from '../types'

export const MoreInfos: FC<MoreInfosProps> = ({ more_information }) => (
  <S.MoreInfos>
    <Row>
      <Col xs={12} lg={7} xl={8} hd={9}>
        {more_information && <Content content={more_information} />}
      </Col>
    </Row>
  </S.MoreInfos>
)
